import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AngularFireModule } from 'angularfire2';
import { AngularFirestoreModule } from 'angularfire2/firestore';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { AngularFireDatabaseModule } from 'angularfire2/database';
import { environment } from '../environments/environment';

import { AppComponent } from './app.component';
import { UiModule } from './ui/ui.module';
import { LoginComponent } from './login/login.component';
import { HomeComponent } from './home/home.component';
import { AuthService } from './services/auth.service';
import { ProfileComponent } from './profile/profile.component';
import { GroupAddComponent } from './group/group-add/group-add.component';
import { GroupDetailComponent } from './group/group-detail/group-detail.component';
import { GroupSettingsComponent } from './group/group-settings/group-settings.component';
import { SafePipe } from './pipes/safe.pipe';
import { GroupMembersComponent } from './group/group-members/group-members.component';
import { UserResolver } from './services/user.resolver';
import { GroupResolver } from './services/group.resolver';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HomeComponent,
    ProfileComponent,
    GroupAddComponent,
    GroupDetailComponent,
    GroupSettingsComponent,
    SafePipe,
    GroupMembersComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    UiModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAuthModule,
    AngularFirestoreModule,
    AngularFireDatabaseModule
  ],
  providers: [
    AuthService,
    UserResolver,
    GroupResolver
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
